export const getAudioBufferFromFile = async (file: File) => {
  const audioContext = new AudioContext();
  const arrayBuffer = await file.arrayBuffer();
  const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
  return audioBuffer;
};

export const trimAudioBuffer = (
  buffer: AudioBuffer,
  startTime: number,
  endTime: number
) => {
  const { sampleRate, numberOfChannels } = buffer;
  const startFrame = startTime * sampleRate;
  const endFrame = endTime * sampleRate;

  const audioContext = new AudioContext();

  const trimmedBuffer = audioContext.createBuffer(
    numberOfChannels,
    endFrame - startFrame,
    sampleRate
  );

  for (let channel = 0; channel < numberOfChannels; channel += 1) {
    const sourceData = buffer
      .getChannelData(channel)
      .subarray(startFrame, endFrame);
    trimmedBuffer.getChannelData(channel).set(sourceData);
  }

  return trimmedBuffer;
};
